/**
 * In-memory access-token cache so apiClient does not call getSession()
 * (NextAuth /api/auth/session) on every request.
 *
 * AuthTokenSync (in providers) keeps this updated from useSession().
 */

type CachedAuth = {
  accessToken: string | null
  error?: string
  expiresAt?: number
}

let cached: CachedAuth = { accessToken: null }

const REFRESH_BUFFER_MS = 60_000

export function setCachedAuth(next: CachedAuth): void {
  cached = {
    accessToken: next.accessToken ?? null,
    error: next.error,
    expiresAt: next.expiresAt,
  }
}

export function clearCachedAuth(): void {
  cached = { accessToken: null }
}

export function getCachedAuth(): CachedAuth {
  return cached
}

/** True when we have a usable token that is not about to expire. */
export function hasFreshCachedToken(): boolean {
  if (!cached.accessToken) return false
  if (cached.error === 'RefreshAccessTokenError') return false
  if (cached.expiresAt != null && cached.expiresAt - Date.now() < REFRESH_BUFFER_MS) {
    return false
  }
  return true
}
